<div class="card">
  <div class="card-body column">
    <h6 class="card">Pesquisa gateway</h6>
    <div class="d-flex">
      <div class="w-25">
        <label>CellId</label>
        <input placeholder="3338" [(ngModel)]="erb.cellid" />
      </div>
      <div class="w-25">
        <label for="lac">Lac</label>
        <input placeholder="1044" [(ngModel)]="erb.lac" />
      </div>
      <div class="w-25">
        <label for="mnc">Mnc</label>
        <input placeholder="5" [(ngModel)]="erb.mnc" />
      </div>
      <div class="w-25">
        <label for="mcc">Mcc</label>
        <input placeholder="724" [(ngModel)]="erb.mcc" />
      </div>
      <div class="column">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          style="margin-right: 5px"
          (click)="searchErb()"
        >
          Pesquisar
        </button>
      </div>
    </div>
  </div>
  <div class="card align-items-center" *ngIf="circularProgressiveWait">
    <div card="card-body">
      <div class="spinner-border text-primary m-1" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div *ngIf="apiLoaded | async">
        <google-map
          [options]="options"
          width="auto"
          height="500px"
        ></google-map>
      </div>
    </div>
  </div>
</div>
